<!-- Dialog: FILTER NEW-->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [draggable]="true"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <div fxLayoutWrap fxLayout="column">
    <div fxLayout="row" fxFlexFill>
      <div fxFlex class="p-autocomplete-float-group">
        <bfx-text-input
          #copyFilter_filterName_autoComplete
          size="sm"
          [(ngModel)]="data.dialogData.autocomplete_filterName"
          inputLabelText="Filter Name"
          autocomplete="off"
          [maxLength]="50"
          (ngModelChange)="helperCreateFilter_validateFilterName($event)"
          autoHighlight="true"
          [style]="{'width':'100%'}"
          [ngClass]="{'p-autocomplete p-autocomplete-float-input filter__dialog__filter-copy__autocomplete--filterName': true,
                        'p-autocomplete-float-input-valid': !!data.dialogData.autocomplete_filterName}"
        >
        </bfx-text-input>
        <div
          class="p-autocomplete-float-label-error"
          [ngStyle]="{ visibility: filterNameValid || filterNameEmpty ? 'hidden' : 'visible'}"
        >
          {{data.dialogData.message_text_invalid}}
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionCreateFilter_close()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionCreateFilter_confirm()"
      label="Create"
      [disabled]="!data.dialogData.autocomplete_filterName || !filterNameValid"
    ></button>
  </p-footer>
</p-dialog>
